
    /**
    * 商家入驻 -【官网v2.5】
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * OfficialMerchantSettleParam :OfficialMerchantSettleParam
 */
export class IReqApiMerchantsSettle25780 {
  /**
   * 公司名称
   */
  companyName: {};
  /**
   * 主营品牌
   */
  mainBrand: {};
  /**
   * 主营类目，多个以英文逗号分隔
   */
  category: {};
  /**
   * 遥望招商对接人
   */
  managerName?: {};
  /**
   * 是否暂无招商对接人,默认否
   */
  noManager?: {};
  /**
   * 联系姓名
   */
  name: {};
  /**
   * 联系电话
   */
  mobile: {};
  /**
   * 微信账号
   */
  wx: {};
}
    /**
 * Response<Void> :Response
 */
export class IResApiMerchantsSettle25780 {
  message?: {};
  code?: {};
  /**
   * Void
   */
  data?: {};
}
    const http: Serve<IReqApiMerchantsSettle25780, IResApiMerchantsSettle25780> = (data?) =>  request({
      method: 'POST',
      url: '/api/merchants/settle',
      data:data
    }) 
    export default http